<div class="component-wrapper">
  <span class="document-import">
    <app-import-documents #importDocumentsComponent
      [patientId]="patientId"
      [consultations]="consultations"
      [consultationTypes]="consultationTypes"
      [dmpTypes]="dmpTypes"
      [patientaccessProfils]="patientaccessProfils"
      [uniqueConsultation]="uniqueConsultation"
      [documentWithoutConsultation]="documentWithoutConsultation"
      (importOver)="importOverFnc()">
    </app-import-documents>
  </span>
  <span class="documents-list" *ngIf="showDisplay">
    <div *ngIf="dataSource?.data?.length">
      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortFnc($event)" class="mat-table">

        <!-- Checkbox pour le comparateur d'images -->
        <ng-container matColumnDef="select" *ngIf="comparisonMode">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
            <mat-checkbox 
              *ngIf="isImageDocument(row)"
              [checked]="isDocumentSelected(row.meta.id)"
              [disabled]="isSelectionLimitReached && !isDocumentSelected(row.meta.id)"
              color="primary"
              style="margin-right: 0.5rem;"
              (change)="toggleSelection(row)">
            </mat-checkbox>
            <mat-icon 
              *ngIf="!isImageDocument(row)" 
              matTooltip="Ce document n'est pas une image"
              style="color: var(--grey2); cursor: not-allowed; margin-right: 0.5rem;">
              block
            </mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Titre document </th>
          <td mat-cell *matCellDef="let row"> {{row.title}} </td>
        </ng-container>

        <ng-container matColumnDef="formatFileSize">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Taille document </th>
          <td mat-cell *matCellDef="let row"> {{row.formatFileSize}} </td>
        </ng-container>

        <ng-container matColumnDef="consultationTitre">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Titre consultation </th>
          <td mat-cell *matCellDef="let row"> {{row.consultationTitre}} </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Date d'intégration </th>
          <td mat-cell *matCellDef="let row"> {{row.createdAt}} </td>
        </ng-container>

        <ng-container matColumnDef="consultationDat">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Date consultation </th>
          <td mat-cell *matCellDef="let row"> {{row.consultationDat}} </td>
        </ng-container>

        <ng-container matColumnDef="envoyeDMP">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> DMP </th>
          <td mat-cell *matCellDef="let row"> {{row.envoyeDMP}} </td>
        </ng-container>

        <ng-container matColumnDef="visibilityDMP">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Visibilité DMP </th>
          <td mat-cell *matCellDef="let row"> {{row.visibilityDMP}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Autres actions </th>
          <td mat-cell *matCellDef="let row" style="margin: auto ;">
            <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="togglePrivateStatus(row)">
                <mat-icon>{{row.meta.isPrivate ? 'lock_open' : 'lock'}}</mat-icon>
                <span>{{row.meta.isPrivate ? 'Rendre public' : 'Marquer comme privé'}}</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="assocConsultation(row)" *ngIf="!uniqueConsultation">
                <span>Associer à une consultation</span>
              </button>
              <button mat-menu-item (click)="createConsultation(row)" *ngIf="!uniqueConsultation">
                <span>Créer une consultation</span>
              </button>
              <button mat-menu-item (click)="sendDocumentToPatient(row)" *ngIf="!uniqueConsultation && canSendToPatient">
                <span>Envoyer automatiquement via MSS au patient</span>
              </button>
              <button mat-menu-item (click)="renameDocument(row)">
                <span>Renommer le document</span>
              </button>
              <button mat-menu-item (click)="removeDocument(row)">
                <span>Supprimer</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <ng-container matColumnDef="info">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <mat-icon matTooltipClass="tooltip-version"
                      [matTooltip]="getTooltipContent(row)"
                      matTooltipPosition="above"
                      aria-label="Informations supplémentaires"
                      style="color: var(--darkest-primary);">
              info
            </mat-icon>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            (dblclick)="openDocument(row)"
            [style.color]="row.textColor">
        </tr>
      </table>

      <mat-paginator [pageSize]="documentsTable?.perpage || 5"
                     [pageSizeOptions]="[5, 10, 25, 50]"
                     [length]="documentsTable?.total || dataSource?.data?.length || 0"
                     [pageIndex]="(documentsTable?.page || 1) - 1"
                     (page)="onPaginator($event)">
      </mat-paginator>
    </div>
  </span>

  <div class="code-couleur-wrapper" *ngIf="showDisplay">
    <div class="code-couleur-row">
      <div class="code-couleur">
        <div class="couleur out-of-range"></div>
        <div class="label">CR Bio contenant des résultats anormaux</div>
      </div>
    </div>
    <div class="code-couleur-row">
      <div class="code-couleur">
        <div class="couleur critical-out-of-range"></div>
        <div class="label">CR Bio contenant des résultats critiques</div>
      </div>
    </div>
  </div>
</div>
